import config from 'constants/config'

export const OFFER_VIEWS_24_HOURS_THRESHOLD = config.OFFER_VIEWS_24_HOURS_THRESHOLD || 50

export function getOfferExtra(state: App.State, offerId: string = '') {
  return state.offer.offerExtras[offerId]?.data
}
